/* eslint-disable react/prop-types */

import { Box, Checkbox, Divider } from "@mui/material";
import React, { useCallback, useState } from "react";
import InputField from "../../../../components/common/new/InputField/InputField";
import Typography from "../../../../components/common/new/Typography/Typography";
import { returnGohonzonQuestions } from "../../../../contants/gohonzon";
import styles from "../GohonzonSubmission.styles";

const TEXTFIELD = "TEXTFIELD";

const clearAllReturnQuestions = (setFieldValue) => {
  returnGohonzonQuestions.forEach((ques) => {
    setFieldValue(ques.name, ques.questionType === TEXTFIELD ? "" : false);
  });
};

function GohonzonReturnForm({ handleChange, values, setFieldValue, readOnly }) {
  const [selectedReturnReasonName, setSelectedReturnReasonName] = useState("");

  const handleReplaceQuesInputs = (value) => {
    if (value) {
      clearAllReturnQuestions(setFieldValue);
      setSelectedReturnReasonName("");
    } else if (values.replacementReason) {
      setFieldValue("replacementReason", "");
    }
  };

  const onReturnReasonChange = (e) => {
    const { name, value, checked } = e.target;
    handleChange(e);

    if (typeof value === "boolean" && checked) {
      setSelectedReturnReasonName(name);
    } else if (typeof value === "string" && value) {
      setSelectedReturnReasonName(name);
    } else {
      setSelectedReturnReasonName("");
    }
  };

  const multiOptionCheck = useCallback(
    (inputNameAttr) =>
      selectedReturnReasonName && inputNameAttr !== selectedReturnReasonName,
    [selectedReturnReasonName]
  );

  return (
    <Box>
      <Box
        style={{
          width: "210px",
          height: "44px",
          flexShrink: "0",
          borderRadius: "35px",
          background: "#196AAB",
          marginBottom: "-25px",
          position: "relative",
          zIndex: "1",
          marginLeft: "45px",
        }}
      >
        <Typography
          variant="title3"
          style={{
            color: "#FFF",
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: "Noto Sans",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "20px",
            padding: "12px 20px 12px 20px",
            margin: "0px",
          }}
        >
          Return & Replacement
        </Typography>
      </Box>
      <Box
        style={{
          borderRadius: "5px 5px 5px 5px",
          border: "1px solid #C2D4EB",
          background: "#F6F6F6",
          padding: "20px 0px 20px 20px",
          borderBottom: "9px solid #196AAB",
          margin: "0px 20px",
        }}
      >
        <Box py="18px">
          <Typography variant="title3" color="#8c8c8c">
            Reason for Returning the Gohozon
          </Typography>
        </Box>
        <Box
          style={{
            ...styles.gridContainerOtherDeatils,
            ...styles.returnReplacementContainer,
          }}
        >
          {returnGohonzonQuestions?.map((question) => {
            return (
              <Box style={styles.gridItem} key={question.key}>
                <Box>
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "#454545",
                      fontFeatureSettings: "'clig' off, 'liga' off",
                      fontStyle: "normal",
                    }}
                  >
                    {question.ques}
                  </span>
                </Box>
                <Box
                  style={
                    question.questionType === TEXTFIELD ? { width: "60%" } : {}
                  }
                >
                  {question?.questionType === TEXTFIELD ? (
                    <InputField
                      name={question.name}
                      InputProps={{ placeholder: "Type your reason" }}
                      onChange={onReturnReasonChange}
                      value={values[question.name]}
                      disabled={
                        readOnly ||
                        values.replaceCheck ||
                        (multiOptionCheck(question.name) &&
                          values[selectedReturnReasonName])
                      }
                    />
                  ) : (
                    <Checkbox
                      name={question.name}
                      size="small"
                      onChange={onReturnReasonChange}
                      value={values[question.name] ?? false}
                      checked={values[question.name] ?? false}
                      disabled={
                        readOnly ||
                        values.replaceCheck ||
                        (multiOptionCheck(question.name) &&
                          values[selectedReturnReasonName])
                      }
                    />
                  )}
                </Box>
              </Box>
            );
          })}
        </Box>
        <Divider style={{ marginTop: "6%" }} />
        <Box style={styles.gridContainer} my={8}>
          <Box>
            <Checkbox
              name="replaceCheck"
              size="small"
              onChange={(e) => {
                handleChange(e);
                handleReplaceQuesInputs(e.target.checked);
              }}
              value={values.replaceCheck ?? false}
              checked={values.replaceCheck ?? false}
              disabled={readOnly || values[selectedReturnReasonName]}
            />
            <span
              style={{
                fontSize: "12px",
                fontWeight: 500,
                color: "#454545",
                fontFeatureSettings: "'clig' off, 'liga' off",
                fontStyle: "normal",
              }}
            >
              Do you wish to replace the Gohonzon?
            </span>
          </Box>
        </Box>
        <Box style={styles.gridContainerOtherDeatils}>
          <span
            style={{
              fontSize: "12px",
              fontWeight: 500,
              color: "#454545",
              fontFeatureSettings: "'clig' off, 'liga' off",
              fontStyle: "normal",
            }}
          >
            REASON FOR REPLACING
          </span>
          <Box
            style={{
              marginLeft: "-10rem",
              marginRight: "5rem",
            }}
          >
            <InputField
              name="replacementReason"
              label="Enter Reason"
              onChange={handleChange}
              value={values.replacementReason}
              disabled={readOnly || !values.replaceCheck}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default GohonzonReturnForm;
